type Variant = 'primary' | 'secondary' | 'dangerSoft' | 'ghost';

const VARIANT_CLASS: Record<Variant, string> = {
  primary: 'btn-primary clay-primary',
  secondary: 'btn-secondary clay-card',
  dangerSoft: 'btn-danger-soft clay-danger',
  ghost: 'btn-ghost',
};

/**
 * Ported from src/components/ui/Button.tsx. The title stays rendered while loading so the
 * button keeps its width — the same trick the native one uses with an invisible label.
 */
export default function Button({
  title,
  onPress,
  variant = 'primary',
  loading = false,
  disabled = false,
  className = '',
  accessibilityLabel,
  type = 'button',
}: {
  title: string;
  /** Omit for a submit button inside a <form>; the form's onSubmit runs instead. */
  onPress?: () => void;
  variant?: Variant;
  loading?: boolean;
  disabled?: boolean;
  className?: string;
  accessibilityLabel?: string;
  type?: 'button' | 'submit';
}) {
  const inactive = disabled || loading;
  return (
    <button
      type={type}
      onClick={onPress}
      disabled={inactive}
      aria-busy={loading || undefined}
      aria-label={accessibilityLabel ?? title}
      className={`btn pressable ${VARIANT_CLASS[variant]} ${className}`.trim()}
    >
      <span className={loading ? 'btn-label is-hidden' : 'btn-label'}>{title}</span>
      {loading && <span className="btn-spinner" aria-hidden="true" />}
    </button>
  );
}
